/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ username: NonNullable<unknown> }} Whatsapp_Bot_Link_SuccessInputs */

const he_whatsapp_bot_link_success = /** @type {(inputs: Whatsapp_Bot_Link_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`שלום ${i?.username}, הווטסאפ שלך מחובר עכשיו ל-pricedrop!`)
};

const en_whatsapp_bot_link_success = /** @type {(inputs: Whatsapp_Bot_Link_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hi ${i?.username}, your WhatsApp is now linked to pricedrop!`)
};

/**
* | output |
* | --- |
* | "Hi {username}, your WhatsApp is now linked to pricedrop!" |
*
* @param {Whatsapp_Bot_Link_SuccessInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const whatsapp_bot_link_success = /** @type {((inputs: Whatsapp_Bot_Link_SuccessInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whatsapp_Bot_Link_SuccessInputs, { locale?: "he" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_whatsapp_bot_link_success(inputs)
	return en_whatsapp_bot_link_success(inputs)
});